export enum Workshops {
    WORKSHOP_1 = 'Workshop 1',
    WORKSHOP_2 = 'Workshop 2',
    WORKSHOP_3 = 'Workshop 3',
  }
  
export default Workshops;
